import uniq from 'lodash/uniq'
import { createReducer } from 'src/utils/reducer'
import * as actions from 'src/constants/actionTypes'
import { CUSTOMERS_URL } from 'src/constants/urls'

export const initialCustomersState = {
    byId: {},
    values: [],
    searchResults: [],
    loading: false,
}

export default createReducer(initialCustomersState, {
    [actions.SEARCH_CUSTOMERS]: (state) => ({
        ...state,
        searchResults: [],
        loading: true,
    }),
    [actions.SEARCH_CUSTOMERS_SUCCESS]: (state, action) => {
        const { results } = action.payload.data
        const searchResults = results.map((customer) => customer.id)
        return {
            ...state,
            byId: {
                ...results.reduce(
                    (agg, customer) => ({
                        ...agg,
                        [customer.id]: customer,
                    }),
                    state.byId
                ),
            },
            values: uniq([...state.values, ...searchResults]),
            searchResults,
            loading: false,
        }
    },
    [actions.SEARCH_CUSTOMERS_ERROR]: (state) => ({
        ...state,
        searchResults: [],
        loading: false,
    }),
    [actions.SEARCH_CUSTOMERS_CLEAR]: (state) => ({
        ...state,
        searchResults: [],
        loading: false,
    }),
    [actions.SET_CUSTOMER_FILTER]: (state) => ({
        ...state,
        searchResults: [],
        loading: false,
    }),
})

export const searchCustomer = (name) => {
    return {
        type: actions.API,
        method: 'get',
        payload: {
            url: `${CUSTOMERS_URL}${(name && name + '/') || ''}`,
            start: () => ({ type: actions.SEARCH_CUSTOMERS }),
            success: (payload) => ({
                type: actions.SEARCH_CUSTOMERS_SUCCESS,
                payload,
            }),
            error: (error) => ({
                type: actions.SEARCH_CUSTOMERS_ERROR,
                error,
            }),
        },
        debounce: {
            key: 'searchCustomers',
            wait: 500,
        },
    }
}

export const clearSearchCustomers = () => ({
    type: actions.SEARCH_CUSTOMERS_CLEAR,
})

export const getCustomers = (state) =>
    state.cmdb.customers.values.map((id) => state.cmdb.customers.byId[id])

export const getCustomerResults = (state) =>
    state.cmdb.customers.searchResults.map(
        (id) => state.cmdb.customers.byId[id]
    )

export const getCustomerById = (state, customerId) =>
    state.cmdb.customers.byId[customerId]
